<template>
    <div class="header">
        <div class="top">
            <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/logo.svg" alt="" class="logo">
            <div>
                <!-- v-if="current!='fy'" -->
                <div class="jp" v-html="$i18n.locale == 'jp' ? '中文' : '日本語'" @click="changeLang()"></div>
                <!-- <img class="jp"
                    :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/zh.png?v=1656' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/jp.png?v=1656'"
                    alt="" @click="changeLang()"> -->
                <!-- <div class="mobile-main" v-if='login'>
                    <span @click="nav()" class="menu_icon" v-bind:class="{ navSwitch: isActive }"></span>
                    <div class="nav-slide-box" v-bind:class="{ open: isActive }">
                        <div class="nav-list menus_list">
                            <p v-for="(item, index) in $t('menu')" :class="{ scollr: index == current }" :key="index"
                                v-if="index == 'menu' || index == 'guest' || index == 'agenda' || index == 'meetingS' || index == 'photo' || index == 'investigation' || index == 'meetingL' || index == 'contact'">
                                <span @click="clear" v-if="index == 'signOut'" class="navOut">{{ item }}</span>
                                <span @click="path(index, $t('menuCn')[index])" v-else :data-path="index">
                                    {{ item }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
        <img class="tops" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/kv.png" alt="">
    </div>
</template>

<script>
export default {
    name: 'guide',
    inject: ['reload'],
    data() {
        return {
            isActive: false,
            lang: localStorage.getItem('nissan2023_meeting_lang'),
            state: false,
            name: "",
            current: '',
            login: false,
            toastShow: false,
            toastText: ""
        }
    },
    created() {
        let that = this;
        // this.name = user.base.name;
        let act = window.location.href.split("/#/")[1];
        that.current = act;
        if (that.current == 'login') {

        } else {
            that.login = true;
        }

        let mobile = localStorage.getItem('nissan2023_meeting_uuid');
        if (mobile == "" || mobile == null) {
            that.$router.replace('/login').catch(() => { })
        }
    },
    methods: {
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
        addClass: function (index) {
            this.current = index;
        },
        changeLang(e) {
            if (localStorage.getItem('nissan2023_meeting_lang') == 'jp') {
                this.$i18n.locale = 'zh'
                localStorage.setItem('nissan2023_meeting_lang', 'zh')
                this.reload();
                document.title = "东风日产供应商年会服务平台"
            } else if (localStorage.getItem('nissan2023_meeting_lang') == 'zh') {
                document.title = "東風日産サプライヤー大会サービスデスク"
                this.$i18n.locale = 'jp'
                localStorage.setItem('nissan2023_meeting_lang', 'jp')
                this.reload();
            }

        },
        nav(types) {
            this.isActive = this.isActive ? false : true;
        },
        path(path, name) {
            let that = this;
            if (name == '首页') {
                that.$router.replace('/' + path).catch((err) => err)
                that.current = path;
            } else {
                that.axios.get('https://rally.event1.cn/api/common/cmenu?title=' + name + '&pro=richankg').then((res) => {
                    if (res.data.code == 1) {
                        if (res.data.data.status == 1) {
                            if (path == 'investigation') {//问卷
                                let meeting_questionnaire = JSON.parse(localStorage.getItem("nissan2023_meeting_user")).meeting_questionnaire;
                                if (meeting_questionnaire == 1) {
                                    that.toast(that.$t('investigation.already'));
                                    that.isActive = that.isActive ? false : true;
                                } else {
                                    that.$router.replace('/' + path).catch((err) => err)
                                    that.current = path;
                                }
                            } else {
                                that.$router.replace('/' + path).catch((err) => err)
                                that.current = path;
                            }
                        } else {
                            that.toast(that.$t('back.waiting'));
                        }

                    } else {
                        that.toast(res.data.msg);
                    }
                }).catch(err => err);
            }

        },
        clear() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login')
        }
    }
}
</script>
<style scoped>
.nav-slide-box .nav-list {
    width: 100%;
    height: auto;
    padding-top: 50px;
    padding-bottom: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/menu.vue